import React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import MapWidget from './Frontend/MapWidget'
import { setupApi } from './Frontend/helpers/apiEndpoints';
import { cleanMapProperties } from './Frontend/helpers/helper';
import { addLinkStylesheet, loadScript } from './Frontend/helpers/sharedUtils';

import './index.css';
import './cbmap.scss';
// fetch('http://localhost:3000/widget/index.css').then((resp) => (resp.text())).then((cssText) => {
//   console.log(cssText);  
//   setStyles(cssText);
// })
const StoreLocatorApp = ()=> {
  const init = ({selector, ...rest}) => {
    const apiDomain = process.env.REACT_APP_REST_API_LOCATION || 'http://localhost:3000';
    setupApi({apiDomain});
    const styleOpts = {unique: true}
    addLinkStylesheet('cbmap-mapbox',`https://api.mapbox.com/mapbox-gl-js/v2.14.1/mapbox-gl.css`, styleOpts)
    addLinkStylesheet('cbmap-osm',`https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.min.css`, styleOpts)
    addLinkStylesheet('cbmap-style',`${apiDomain}/widget/index.css`, styleOpts)
    loadScript('https://api.mapbox.com/mapbox-gl-js/v2.14.1/mapbox-gl.js', {className: 'cbmap-mapbox-cdn'});
    document.querySelectorAll(selector).forEach((element) => {
      console.log(element)
      if (!element.dataset.mapLoaded) {
        const mapRoot = createRoot(element);
        // console.log('container', container, container.dataset)    
        // lang: en/vi
        // geolocation: true/false
        // mapCenterLat: lat
        // mapCenterLng: lng
        // selectedLocation: location-slug
        // filtersLayout: "topdropdown","toprow","insideicon","insiderow"      
        // tagsLayout: dropdown/row
        // contentPosition: top-top/left-top/left-bottom/right-top/right-bottom/bottom-bottom
        // hiddenFilters: all/tags/types/radiuses
        // enabledTags: null or 'tag1,tag2,tag3'
        // selectedTags: tag1,tag2,tag3,...
        // enabledTypes: null or 'type1,type2,...'
        // selectedType: typeid
        // enabledRegions: all, country, state, city
          const data = cleanMapProperties(element.dataset);
          element.dataset.mapLoaded = 1;
          const props = {
            ...cleanMapProperties(rest),
            ...data 
          }
          if (!!element.style.height) {
            props.widgetHeight = element.offsetHeight;
          }
          // console.log('element', element, element.styles, element.offsetHeight, props)
          mapRoot.render(<MapWidget accountId={element.dataset.accountId} {...props}/>);
      }
      addLinkStylesheet('cbmap-style-custom',`${apiDomain}/custom/${element.dataset.accountId}.css`, styleOpts)
    })
  }
  return {
    init
  }
};

window.StoreLocatorApp = StoreLocatorApp()
window.CBMaps = StoreLocatorApp()
window.StoreLocatorApp.init({
  selector: '.cbmaps-store-locator'
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
